'use strict';
(function () {
	angular
		.module('onboarding.common')
		.directive('cobUploadedDocuments', cobUploadedDocuments);

	cobUploadedDocuments.$inject = ['spinnerService', 'carrierDocumentsService', 'orderByFilter'];

	var spinnerService,
		carrierDocumentsService,
		orderBy;

	function cobUploadedDocuments(
		_spinnerService_,
		_carrierDocumentsService_,
		_orderByFilter_) {
			
		spinnerService = _spinnerService_;
		carrierDocumentsService = _carrierDocumentsService_;
		orderBy = _orderByFilter_;

		return {
			restrict: 'E',
			scope: {
				documents: '=',
				pageLimit: '=',
				carrierId: '=',
				fileUploadedRecently: '=',
				uploadResult: '=',
				headerInfo: '=',
				actionsAllowed: '=',
				uploadedAdditionalMessage: '=',
				validationMessage: '=',
				documentsLimit: '=',
				isRequired: '=',
				showPagination: '=',
				fileUploadCallback: '&',
				fileDeleteCallback: '&'
			},
			templateUrl: '/app/common/directives/cobUploadedDocuments.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			scope.confirmDelete = confirmDelete;
			scope.cancelDelete = cancelDelete;
			scope.cancelErrorModal = cancelErrorModal;
			scope.onTrashClick = onTrashClick;
			scope.fileUpload = fileUpload;
			scope.paginationUpdateCallback = paginationUpdateCallback;
			scope.isFileLimit = isFileLimit;
			scope.isFileUploadedMessageValid = isFileUploadedMessageValid;

			scope.paginationSettings = {
				currentPage: 0,
				offset: 0,
				pageLimit: scope.pageLimit,
				pageLimits: [scope.pageLimit]
			};

			scope.$watch('documents', function(value) {
				scope.documents = orderBy(value, '-dateUploaded');
			}, true);
		}

		function onTrashClick(index) {
			var startIndex = getStartIndex();
			var document = scope.documents[startIndex + index];
			scope.deleteDocument = document;
		}

		function confirmDelete() {
			spinnerService.startSpinner(scope);

			scope.deleteDocument.documentStatus = 'INACTIVE';

			carrierDocumentsService.editDocument(scope.deleteDocument, scope.carrierId)
				.then(function (response) {
					if (response.data.isSuccess) {
						var index = scope.documents.indexOf(scope.deleteDocument);
						scope.documents.splice(index, 1);
						if (scope.documents.length <= getStartIndex()) {
							previousPage();
						}

						scope.fileDeleteCallback(scope.deleteDocument);
					}
				}).finally(function () {
					spinnerService.stopSpinner(scope);
					scope.deleteDocument = {};
				});
		}

		function cancelDelete() {
			scope.deleteDocument = {};
		}
		function cancelErrorModal() {
			scope.uploadResult = {};
		}

		function fileUpload(file) {
			scope.fileUploadCallback({
				file: file
			});
		}

		function paginationUpdateCallback(offset) {
			scope.paginationSettings.offset = offset;
		}

		function getStartIndex() {
			return scope.paginationSettings.currentPage * scope.paginationSettings.pageLimit;
		}

		function previousPage() {
			if (scope.paginationSettings.currentPage > 0) {
				scope.paginationSettings.currentPage -= 1;
				scope.paginationSettings.offset = scope.paginationSettings.currentPage * scope.paginationSettings.pageLimit;
			}
		}

		function isFileUploadedMessageValid() {
			return scope.documents && scope.documents.length > 0 && (scope.fileUploadedRecently || isFileLimit());
		}

		function isFileLimit() {
			return scope.documentsLimit && scope.documents.length >= scope.documentsLimit;
		}
	}
})();
